import { useNavigate } from 'react-router'
import { Mail } from 'lucide-react'
import { NOTIFICATION_CHANNELS, type NotificationChannel } from '@concours/shared'
import { Alert, Badge, Card, PageHeader, Table, type Column } from '@concours/ui'
import { errorMessage } from '../../lib/errors'
import { when } from '../../lib/competition-types'
import { useTemplates, type TemplateEntry } from '../../lib/notifications'

const CHANNELS: NotificationChannel[] = ['portal', 'email', 'sms']

/** Modèles de notification par événement (cahier §12, ADR-010). */
export function TemplatesPage() {
  const navigate = useNavigate()
  const templates = useTemplates()
  const columns: Column<TemplateEntry>[] = [
    {
      key: 'event',
      header: 'Événement',
      cell: (t) => (
        <span className="stack" style={{ gap: 2 }}>
          <strong>{t.label}</strong>
          <span className="muted">{t.description}</span>
        </span>
      ),
    },
    {
      key: 'channels',
      header: 'Canaux actifs',
      cell: (t) => (
        <span className="row" style={{ gap: 'var(--space-1)', flexWrap: 'wrap' }}>
          {CHANNELS.filter((c) => t.template[c].enabled).map((c) => (
            <Badge key={c} variant={c === 'sms' ? 'sahel' : 'outline'}>
              {NOTIFICATION_CHANNELS[c]}
            </Badge>
          ))}
        </span>
      ),
    },
    {
      key: 'version',
      header: 'Modèle',
      cell: (t) =>
        t.customized ? (
          <span className="stack" style={{ gap: 2 }}>
            <Badge variant="info">Personnalisé · v{t.version}</Badge>
            <span className="muted">
              {t.updatedBy ?? '—'}, {when(t.updatedAt)}
            </span>
          </span>
        ) : (
          <span className="muted">Par défaut</span>
        ),
    },
  ]
  return (
    <>
      <PageHeader
        eyebrow="Administration"
        title="Modèles de notification"
        description="Textes envoyés à chaque événement, par canal. Courriel et SMS restent minimaux : aucune note, aucun rang, aucun motif détaillé — le détail se consulte dans l’espace candidat."
      />
      {templates.isError && <Alert tone="danger">{errorMessage(templates.error)}</Alert>}
      <Card>
        <Table
          columns={columns}
          rows={templates.data?.data ?? []}
          rowKey={(t) => t.event}
          loading={templates.isPending}
          caption="Modèles de notification"
          onRowClick={(t) => navigate(`/notifications/modeles/${t.event}`)}
          empty={<Mail aria-hidden="true" />}
        />
      </Card>
    </>
  )
}
